module.exports = __webpack_public_path__ + "img/p002.9b8712f0.png";